import { createStateHook, createNextHook } from '@restate/core'
import { AppStoreProvider } from 'state/store'

export const useTraineeSharesState = createStateHook(
  AppStoreProvider,
  state => state.pages.traineeShares
)
export const useNextTraineeSharesState = () =>
  createNextHook(AppStoreProvider, state => state.pages.traineeShares)
